export class CalendarRole {
    title: string;
    mail: string;
    responsibleId = 0;
    calendarId = 0;
    color = 0;
    id = 0;
}
